"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectComponents = void 0;
const gs = require("@ivanlog/gs");
const com = require("./tmpls");
const CmpAdminLeftMenu_1 = require("./CmpAdminLeftMenu");
const CmpBottomNavigation_1 = require("./CmpBottomNavigation");
const CmpCatalog_1 = require("./CmpCatalog");
const CmpFilterLine_1 = require("./CmpFilterLine");
const CmpPopRightAuth_1 = require("./CmpPopRightAuth");
const CmpProductCartTile_1 = require("./CmpProductCartTile");
const CmpProductTile_1 = require("./CmpProductTile");
const CmpProfileConfig_1 = require("./CmpProfileConfig");
const CmpProfileFAQ_1 = require("./CmpProfileFAQ");
const CmpProfileOrders_1 = require("./CmpProfileOrders");
const CmpProfileOrdersItem_1 = require("./CmpProfileOrdersItem");
const CmpTopMenu_1 = require("./CmpTopMenu");
const CmpTopMenuMobile_1 = require("./CmpTopMenuMobile");
const CmpWidgetOffer_1 = require("./CmpWidgetOffer");
const CmpWidgetSale_1 = require("./CmpWidgetSale");
const LayoutDesktop_1 = require("./LayoutDesktop");
const PageProductsFavourites_1 = require("./PageProductsFavourites");
const InjectComponents = () => { };
exports.InjectComponents = InjectComponents;
gs.WrapperGS.InjectComponents(com.CmpAdminChatMessage, 'cmpAdminChatMessage');
gs.WrapperGS.InjectComponents(com.CmpAdminJobApplicationsItem, 'cmpAdminJobApplicationsItem');
gs.WrapperGS.InjectComponents(com.CmpAdminKeyWord, 'cmpAdminKeyWord');
gs.WrapperGS.InjectComponents(CmpAdminLeftMenu_1.CmpAdminLeftMenu, 'cmpAdminLeftMenu');
gs.WrapperGS.InjectComponents(com.CmpAdminListFilter, 'cmpAdminListFilter');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadArticleInfo, 'cmpAdminListHeadArticleInfo');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadArticleNews, 'cmpAdminListHeadArticleNews');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadHH, 'cmpAdminListHeadHH');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadProdQuestion, 'cmpAdminListHeadProdQuestion');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadProdReview, 'cmpAdminListHeadProdReview');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadSupport, 'cmpAdminListHeadSupport');
gs.WrapperGS.InjectComponents(com.CmpAdminListHeadUser, 'cmpAdminListHeadUser');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemArticleInfo, 'cmpAdminListItemArticleInfo');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemArticleNews, 'cmpAdminListItemArticleNews');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemHH, 'cmpAdminListItemHH');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemProdQuestion, 'cmpAdminListItemProdQuestion');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemProdReview, 'cmpAdminListItemProdReview');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemSupport, 'cmpAdminListItemSupport');
gs.WrapperGS.InjectComponents(com.CmpAdminListItemUser, 'cmpAdminListItemUser');
gs.WrapperGS.InjectComponents(com.CmpAdminPagePagination, 'cmpAdminPagePagination');
gs.WrapperGS.InjectComponents(com.CmpAdminPublicationControl, 'cmpAdminPublicationControl');
gs.WrapperGS.InjectComponents(com.CmpAdminTextEditor, 'cmpAdminTextEditor');
gs.WrapperGS.InjectComponents(com.CmpArticleInfoTile, 'cmpArticleInfoTile');
gs.WrapperGS.InjectComponents(com.CmpArticleNewsTile, 'cmpArticleNewsTile');
gs.WrapperGS.InjectComponents(com.CmpArticleSaleTile, 'cmpArticleSaleTile');
gs.WrapperGS.InjectComponents(CmpBottomNavigation_1.CmpBottomNavigation, 'cmpBottomNavigation');
gs.WrapperGS.InjectComponents(com.CmpBreadcrumbs, 'cmpBreadcrumbs');
gs.WrapperGS.InjectComponents(com.CmpCartTotal, 'cmpCartTotal');
gs.WrapperGS.InjectComponents(CmpCatalog_1.CmpCatalog, 'cmpCatalog');
gs.WrapperGS.InjectComponents(com.CmpCatalogItem, 'cmpCatalogItem');
gs.WrapperGS.InjectComponents(com.CmpCatalogItemTop, 'cmpCatalogItemTop');
gs.WrapperGS.InjectComponents(CmpFilterLine_1.CmpFilterLine, 'cmpFilterLine');
gs.WrapperGS.InjectComponents(com.CmpFooter, 'cmpFooter');
gs.WrapperGS.InjectComponents(com.CmpPagination, 'cmpPagination');
gs.WrapperGS.InjectComponents(com.CmpPopCallbackDialog, 'cmpPopCallbackDialog');
gs.WrapperGS.InjectComponents(com.CmpPopLeftFilter, 'cmpPopLeftFilter');
gs.WrapperGS.InjectComponents(CmpPopRightAuth_1.CmpPopRightAuth, 'cmpPopRightAuth');
gs.WrapperGS.InjectComponents(com.CmpPopRightInfo, 'cmpPopRightInfo');
gs.WrapperGS.InjectComponents(com.CmpPopYesNoCancelDialog, 'cmpPopYesNoCancelDialog');
gs.WrapperGS.InjectComponents(CmpProductCartTile_1.CmpProductCartTile, 'cmpProductCartTile');
gs.WrapperGS.InjectComponents(com.CmpProductDetailItem, 'cmpProductDetailItem');
gs.WrapperGS.InjectComponents(com.CmpProductFAQItem, 'cmpProductFAQItem');
gs.WrapperGS.InjectComponents(com.CmpProductOfferTile, 'cmpProductOfferTile');
gs.WrapperGS.InjectComponents(com.CmpProductsCommentsItem, 'cmpProductsCommentsItem');
gs.WrapperGS.InjectComponents(com.CmpProductsTabComments, 'cmpProductsTabComments');
gs.WrapperGS.InjectComponents(com.CmpProductTabDetails, 'cmpProductTabDetails');
gs.WrapperGS.InjectComponents(com.CmpProductTabFAQ, 'cmpProductTabFAQ');
gs.WrapperGS.InjectComponents(com.CmpProductTabMain, 'cmpProductTabMain');
gs.WrapperGS.InjectComponents(CmpProductTile_1.CmpProductTile, 'cmpProductTile');
gs.WrapperGS.InjectComponents(CmpProfileConfig_1.CmpProfileConfig, 'cmpProfileConfig');
gs.WrapperGS.InjectComponents(CmpProfileFAQ_1.CmpProfileFAQ, 'cmpProfileFAQ');
gs.WrapperGS.InjectComponents(com.CmpProfileNavigation, 'cmpProfileNavigation');
gs.WrapperGS.InjectComponents(com.CmpProfileNotifications, 'cmpProfileNotifications');
gs.WrapperGS.InjectComponents(CmpProfileOrders_1.CmpProfileOrders, 'cmpProfileOrders');
gs.WrapperGS.InjectComponents(CmpProfileOrdersItem_1.CmpProfileOrdersItem, 'cmpProfileOrdersItem');
gs.WrapperGS.InjectComponents(com.CmpProfileOrdersItemProduct, 'cmpProfileOrdersItemProduct');
gs.WrapperGS.InjectComponents(com.CmpProfileSupport, 'cmpProfileSupport');
gs.WrapperGS.InjectComponents(com.CmpProguctCategory, 'cmpProguctCategory');
gs.WrapperGS.InjectComponents(com.CmpShareDropdown, 'cmpShareDropdown');
gs.WrapperGS.InjectComponents(com.CmpSliderControl, 'cmpSliderControl');
gs.WrapperGS.InjectComponents(com.CmpTestMode, 'cmpTestMode');
gs.WrapperGS.InjectComponents(CmpTopMenu_1.CmpTopMenu, 'cmpTopMenu');
gs.WrapperGS.InjectComponents(com.CmpTopMenuCartItem, 'cmpTopMenuCartItem');
gs.WrapperGS.InjectComponents(CmpTopMenuMobile_1.CmpTopMenuMobile, 'cmpTopMenuMobile');
gs.WrapperGS.InjectComponents(com.CmpTopSearch, 'cmpTopSearch');
gs.WrapperGS.InjectComponents(com.CmpWidgetArticles, 'cmpWidgetArticles');
gs.WrapperGS.InjectComponents(com.CmpWidgetArticlesNews, 'cmpWidgetArticlesNews');
gs.WrapperGS.InjectComponents(com.CmpWidgetArticlesSale, 'cmpWidgetArticlesSale');
gs.WrapperGS.InjectComponents(com.CmpWidgetCategories, 'cmpWidgetCategories');
gs.WrapperGS.InjectComponents(com.CmpWidgetLicenses, 'cmpWidgetLicenses');
gs.WrapperGS.InjectComponents(CmpWidgetOffer_1.CmpWidgetOffer, 'cmpWidgetOffer');
gs.WrapperGS.InjectComponents(com.CmpWidgetOfferGallery, 'cmpWidgetOfferGallery');
gs.WrapperGS.InjectComponents(com.CmpWidgetPMHistory, 'cmpWidgetPMHistory');
gs.WrapperGS.InjectComponents(com.CmpWidgetProductCategory, 'cmpWidgetProductCategory');
gs.WrapperGS.InjectComponents(CmpWidgetSale_1.CmpWidgetSale, 'cmpWidgetSale');
gs.WrapperGS.InjectComponents(com.CmpWidgetSupplier, 'cmpWidgetSupplier');
gs.WrapperGS.InjectComponents(com.LayoutAdmin, 'layoutAdmin');
gs.WrapperGS.InjectComponents(LayoutDesktop_1.LayoutDesktop, 'layoutDesktop');
gs.WrapperGS.InjectComponents(com.Page404, 'page404');
gs.WrapperGS.InjectComponents(com.PageAboutCompany, 'pageAboutCompany');
gs.WrapperGS.InjectComponents(com.PageAdminChat, 'pageAdminChat');
gs.WrapperGS.InjectComponents(com.PageAdminCreateSearchItem, 'pageAdminCreateSearchItem');
gs.WrapperGS.InjectComponents(com.PageAdminCreateUser, 'pageAdminCreateUser');
gs.WrapperGS.InjectComponents(com.PageAdminEmpty, 'pageAdminEmpty');
gs.WrapperGS.InjectComponents(com.PageAdminHHAnswers, 'pageAdminHHAnswers');
gs.WrapperGS.InjectComponents(com.PageAdminList, 'pageAdminList');
gs.WrapperGS.InjectComponents(com.PageAdminNewArticle, 'pageAdminNewArticle');
gs.WrapperGS.InjectComponents(com.PageAdminNewArticleSale, 'pageAdminNewArticleSale');
gs.WrapperGS.InjectComponents(com.PageAdminNewHH, 'pageAdminNewHH');
gs.WrapperGS.InjectComponents(com.PageAdminProfileConfig, 'pageAdminProfileConfig');
gs.WrapperGS.InjectComponents(com.PageAdminReview, 'pageAdminReview');
gs.WrapperGS.InjectComponents(com.PageAdminSelectPromotion, 'pageAdminSelectPromotion');
gs.WrapperGS.InjectComponents(com.PageArticlesInfo, 'pageArticlesInfo');
gs.WrapperGS.InjectComponents(com.PageArticlesNews, 'pageArticlesNews');
gs.WrapperGS.InjectComponents(com.PageArticlesNewsAndInfo, 'pageArticlesNewsAndInfo');
gs.WrapperGS.InjectComponents(com.PageArticlesSale, 'pageArticlesSale');
gs.WrapperGS.InjectComponents(com.PageCart, 'pageCart');
gs.WrapperGS.InjectComponents(com.PageContacts, 'pageContacts');
gs.WrapperGS.InjectComponents(com.PageDocument, 'pageDocument');
gs.WrapperGS.InjectComponents(com.PageHeadHunt, 'pageHeadHunt');
gs.WrapperGS.InjectComponents(com.PageLegalInfo, 'pageLegalInfo');
gs.WrapperGS.InjectComponents(com.PageLoading, 'pageLoading');
gs.WrapperGS.InjectComponents(com.PageMain, 'pageMain');
gs.WrapperGS.InjectComponents(com.PageNews, 'pageNews');
gs.WrapperGS.InjectComponents(com.PageOrderNew, 'pageOrderNew');
gs.WrapperGS.InjectComponents(com.PageProduct, 'pageProduct');
gs.WrapperGS.InjectComponents(com.PageProductAddComment, 'pageProductAddComment');
gs.WrapperGS.InjectComponents(com.PageProducts, 'pageProducts');
gs.WrapperGS.InjectComponents(PageProductsFavourites_1.PageProductsFavourites, 'pageProductsFavourites');
gs.WrapperGS.InjectComponents(com.PageProfile, 'pageProfile');
//# sourceMappingURL=tmplsInj.js.map